const initialState = {};

const reducerName = 'ChatMessages';
const chatMessagesDictionaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Get'.concat(reducerName):
      return state[action.key];
    case 'Insert'.concat(reducerName):
      return {
        ...state,
        [action.key]: {
          results: action.payload.results,
          total: action.payload.total ?? state.total,
        },
      };
    case 'Append'.concat(reducerName):
      return {
        ...state,
        [action.key]: {
          results: (state[action.key]?.results || []).concat(action.payload),
          total:
            (state[action.key]?.total ?? -1) < 0
              ? -1
              : state[action.key].total + 1,
        },
      };
    case 'Prepend'.concat(reducerName):
      return {
        ...state,
        [action.key]: {
          results: [
            ...action.payload.results.filter(
              incoming =>
                state[action.key].results.some(
                  current => current.id === incoming.id,
                ) === false,
            ),
            ...state[action.key].results,
          ],
          total: action.payload.total ?? state.total,
        },
      };
    case 'Delete'.concat(reducerName):
      return {
        ...state,
        [action.key]: {
          results: state[action.key].results.filter(
            chatMessage => chatMessage.id !== action.payload.id,
          ),
          total: state.total - 1,
        },
      };
    default:
      return state;
  }
};

export default chatMessagesDictionaryReducer;
